import Vue from "vue";

const store = Vue.observable({
  list: []
});

export const mutations = {
  list(list) {
    store.list = list;
  }
};

export const getters = {
  list() {
    return store.list;
  }
};
